<template>
	<article class="panel is-relative">
		<div class="panel-heading">
			<transition name="bounce" mode="out-in">
			<div :style="panelStyle" class="" :key="title">
				<div v-if="url != ''">
					<router-link class="is-link" :to="url">
						<font-awesome-icon v-if="icon" :icon="icon"/>&nbsp;
						{{title}}
					</router-link>
				</div>
				<div v-else>
					<font-awesome-icon v-if="icon" :icon="icon"/>&nbsp;
					<span v-html="title"></span>
					
					<div class="is-pulled-right helpButton" v-if="help" @click.prevent="helpClick">
						<font-awesome-icon class="is-pulled-right" icon="question-circle"/>
					</div>
				</div>
			</div>
			</transition>
		</div>
		<slot></slot>
	</article>
</template>

<script>
export default {
	name: 'Panel',
	props: {
		title: {
		    type: String, // String, Number, Boolean, Function, Object, Array
		    required: true
		},
		icon: {
			type: String,
			required: false
		},
		panelStyle: {
			type: String,
			required: false
		},
		url: {
			type: String,
			required: false,
			default: ''
		},
		help: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {

		};
	},
	methods: {
		helpClick(){
			this.$emit('helpClicked')
		}
	},
};
</script>

<style lang="css" scoped>
.helpButton{
	cursor: pointer;
}
</style>
